import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import generateImagePath from '../../utils/generateImagePath';

import InternalHero from '../../components/organisms/InternalHero';

const Markup = ({ data }) => {
  const { login } = useSelector((state) => state.user.profile);
  return (
    <InternalHero data={data.image ? generateImagePath(data, login) : null} />
  );
};

Markup.propTypes = {
  data: PropTypes.object.isRequired, // eslint-disable-line
};

export default Markup;
